import { V3Record } from "data/helpers/V3Record.js";

export const Event = V3Record("event", {
  id: null,
  name: null,
  allDay: null,
  implicitEndsAt: null,
  startsOn: null,
  endsOn: null,
  startsAt: null,
  endsAt: null,
  slug: null,
  location: null,
  desc: null,
  userId: null,
  userName: null,
  groupId: null,
  highlightedPhotoId: null,
  organizerNames: null,
  tagNames: null,
  updatedAt: null,
});
